module.exports = __webpack_public_path__ + "static/media/69.fe6b8b2b.jpg";